/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetProduct200ResponseData } from './GetProduct200ResponseData'
import {
  GetProduct200ResponseDataFromJSON,
  GetProduct200ResponseDataFromJSONTyped,
  GetProduct200ResponseDataToJSON,
} from './GetProduct200ResponseData'

/**
 *
 * @export
 * @interface GetProduct200Response
 */
export interface GetProduct200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetProduct200Response
   */
  status: boolean
  /**
   *
   * @type {GetProduct200ResponseData}
   * @memberof GetProduct200Response
   */
  data: GetProduct200ResponseData
}

/**
 * Check if a given object implements the GetProduct200Response interface.
 */
export function instanceOfGetProduct200Response(
  value: object
): value is GetProduct200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetProduct200ResponseFromJSON(
  json: any
): GetProduct200Response {
  return GetProduct200ResponseFromJSONTyped(json, false)
}

export function GetProduct200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetProduct200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetProduct200ResponseDataFromJSON(json['data']),
  }
}

export function GetProduct200ResponseToJSON(
  value?: GetProduct200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetProduct200ResponseDataToJSON(value['data']),
  }
}
